export default function setupAnalytics() {
  const iziButtons = document.querySelectorAll(".izi-widget-placeholder");

  if (!iziButtons.length) return;
  if (typeof InpostIziJavsscriptWoocommerce !== "object") return;

  const trackingIds = getTrackingIdsFromLocalStorage();

  document.querySelectorAll("form").forEach((form) => {
    const hasSubmit = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!hasSubmit) return;

    ["gclid", "fbclid", "client_id"].forEach((key) => {
      const value = trackingIds[key];
      if (value && !form.querySelector(`[name="inpostpay_${key}"]`)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `inpostpay_${key}`;
        input.value = value;
        form.appendChild(input);
      }
    });
  });
}

export function getTrackingIdsFromLocalStorage(withMessage = true) {
  try {
    return {
      gclid: localStorage.getItem("gclid") || null,
      fbclid: localStorage.getItem("fbclid") || null,
      client_id: localStorage.getItem("client_id") || null,
    };
  } catch (e) {
    if (withMessage) {
      console.error("Błąd przy odczycie identyfikatorów z localStorage:", e);
    }
    return { gclid: null, fbclid: null, client_id: null };
  }
}
